import React from 'react';
import { Outlet } from 'react-router';

import { FlagKey } from 'api/types';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { LoadingLogo } from 'shared/components/Modal/LoadingLogo';
import { NoMatch } from 'shared/components/NoMatch/NoMatch';

type Props = {
  flagKey: FlagKey;
  children?: JSX.Element;
};

export function FeatureFlagGuard({ flagKey, children }: Props) {
  const { flags, loading } = useFeatureFlags();

  if (loading) return <LoadingLogo />;

  const isEnabled = flags[flagKey];

  if (!isEnabled) {
    return <NoMatch />;
  }

  return children || <Outlet />;
}

export default FeatureFlagGuard;
